/* eslint-disable no-console */

import axios from 'axios';
import router from '../router';
import store from '../store/store';
import config from './config/config';

const HTTP_GESCOM = axios.create();

// Add a request interceptor
HTTP_GESCOM.interceptors.request.use((request) => {
  request.headers = {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + store.getters['user/accessToken'],
  };
  if (request.url.indexOf('http') === -1) {
    // Do something before request is sent
    request.url = config.BASE_URL_GESCOM + request.url;
  }
  return request;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
HTTP_GESCOM.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const site = store.getters['user/site'];
  if (error.response?.status === 401) {
    store.dispatch('user/logOut').then(() => {
      router.push({ name: 'login', query: { site: site, returnUrl: window.location.href } });
      router.go(0);
    });
  }
  throw error;
});

export default HTTP_GESCOM;
